import $ from 'jquery';

function initFitnessJS(){
  var countdown = 0,
      resetCount = null,
	  updateCount = null,
      scriptLength = $('.swiper-slide .data-slide').length,
      userData = JSON.parse(localStorage.getItem('userData')),
      url = null,
      videoTime = 0,
      interval = 1;
	  
	var playerFunctions = window['playerFunctions'];

  if ( !window['hostRejoin'] ) { window.isPaused = false; }
  
  window['demandScriptName'] = '';
  window.startSlider = () => {
      $('#play-slider').addClass('d-none');
      $('#play-slider').removeClass('d-inline-block');
      $('#pause-slider').removeClass('d-none');
      $('#pause-slider').addClass('d-inline-block');
      $(".swiper-slide.start a").prop('disabled', true);
      $(".swiper-btn-next").css("display", "block");
      $(".swiper-slide").removeClass("remove-slider-bg");
      $(".start").removeClass("swiper-start");
      window.countDown();
  }

  window.countDown = () => {
	  console.log('countDown function called');
  	clearInterval(resetCount);
    interval = 1;
    let activeEle = $('.swiper-slide.swiper-slide-next');
    let getInjectEle = activeEle.find('.injectVideo');
    let getInjectEleReap = activeEle.find('.injectVideoReap');
    let repeatVdo = parseInt(getInjectEleReap.attr('repeatvideo'));
	let canStartInjected = true; 
    if ( userData.userType == 1 && window['onDemand'] == undefined )
    {
    	$('#fitness-counter').text(parseInt(activeEle.attr('data-index')));
    }
    else
		{
			let counter = 0;
			let activeScriptFound = false;
	        $('.swiper-slide').each(function(i, val){          
	            if ( $(this).find('.data-slide').length === 1 && !activeScriptFound )
	            {
	        		counter++;
	        		
	        		if ( $(this).hasClass('swiper-slide-next') )
	        		{
	        			activeScriptFound = true;
	        		}
	            }
	        });

	        $('#fitness-counter').text(counter);
		}

    activeEle.removeClass("remove-slider-bg");
    $('#activity-'+activeEle.attr('id')).addClass('activity-current');
	setTimeout(function(){
		var scrollOffset = 0;
		if ( $('.activity-current').is(":visible") )
			{
				scrollOffset = $('.activity-current').position().top;
			}
		  
		$('.activity_list_popup').scrollTop(scrollOffset);
	}, 1000);

    let scriptDelay = activeEle.find('.interval');
    if ( scriptDelay.length === 1 ) { 
        interval = parseInt(scriptDelay.attr('intervaltime'));
    }

    var countdownNumberEl = activeEle.find('.countdown-number');
    let scriptnameClass = activeEle.find('.scriptName');
    let script_name = scriptnameClass.html();
  	let act_type = window['checkActivityType'](window.$('.swiper-slide-next .data-slide').attr('data-index')-1);
	  console.log('countDown act_type', act_type);
  	let act_type_past = window['checkActivityType'](window.$('.swiper-slide-next .data-slide').attr('data-index')-2);
  	let act_type_next = window['checkActivityType'](window.$('.swiper-slide-next .data-slide').attr('data-index'));
  	let startOverSound = false;
	let startTime = countdownNumberEl.attr('data-number');
	let barIncreaseNum = 100/startTime;
	
	if ( window['onDemand'] )
		{
			if ( !window['onDemandWASDone'] && window['hasConeScript'] && act_type !== 'Virtual Equipment' && act_type !== 'Virtual Assistant' && !window['deviceNotSupported'] )
				{
					script_name = activeEle.find('.new_script_name_part').html();
					window['onDemandStarted'] = false;
					window['demandScriptName'] = script_name;
					window.$('.participant_stats_hold').addClass('d-none');
					window['repCounting'] = 0;
					window['missRepCounting'] = 0;
					$('#repcounter').html('0');
					window.startDrawing(script_name);
				}
			
			var startVirtual = false;
			if ( !window['deviceNotSupported'] )
				{
					if ( act_type == 'Virtual Equipment' || act_type == 'Virtual Assistant' ) 
						{
							script_name = activeEle.find('.new_script_name_part').html();
							startVirtual = true; 
						}
				
					if ( act_type == 'Pause' || act_type == 'Pause Virtual' )
						{
							if ( act_type_next ) 
								{
									var nextActIndex = $('.swiper-slide-next .data-slide').attr('data-index');
									if ( act_type_next == 'Pause' || act_type_next == 'Pause Virtual' )
										{
											act_type_next = window['checkActivityType'](window.$('.swiper-slide-next .data-slide').attr('data-index')+1);
											nextActIndex++;
										}
									
									if ( act_type_next && (act_type_next == 'Virtual Equipment' || act_type_next == 'Virtual Assistant') )
										{
											script_name = $('#swiper-slide'+nextActIndex).find('.new_script_name_part').html();
											startVirtual = true;
										}
								}
						}
				}
				
			if ( startVirtual )
				{
					window['coneScriptActive'] = true;
					window['coneScriptEnd'] = false;
					
					window['onDemandStarted'] = false;
					window['demandScriptName'] = script_name;
					window.$('.participant_stats_hold').addClass('d-none');
					if ( window['viewCaptured'+userData.id] && window['workoutAreaSetupDone'+userData.id] ) 
						{
							window.$('#setupEquipmentHoldDem').removeClass('whiteBkg');
						    window.$('#setupEquipmentHoldDem').attr('style', '');
							window.$('#movedEquipmentDem').removeClass('smallerButton').html('Set up equipment');
							window.$('#setupEquipmentHoldDem').removeClass('d-none');
							window.$('#movedEquipmentDem').removeClass('d-none');
							window.$('#movedEquipmentTextDem').addClass('d-none');
							window['hostStartedEquipment'+userData.id] = false;							
							window['didAnimationBag'+userData.id] = false;							
						}
					window['repCounting'] = 0;
					window['missRepCounting'] = 0;
					$('#repcounter').html('0');
					console.log('script_name', script_name);
					if ( act_type != 'Pause Virtual' ) { window.pauseVirtualActivityStarted = false; window.startDrawing(script_name, act_type); }
					else { window.pauseVirtualActivityStarted = true; window.startPauseVirtual(script_name); }
					
					//window['trackerInitialize'](act_name);
					//window['setTrackerSides'](act_name);
				}
			else
				{
					window.pauseVirtualActivityStarted = false;
					if ( window['userWhiteboard'][userData.id] && window['userWhiteboard'][userData.id].roomSetup.workoutAreaSetupDone ) { window.closeDrawing(); }
				}
		}
	
	window['activityEnded'] = false;
	
	if ( window['guestUser'] && window['onDemand'] == undefined)
		{
			var script_name_participant = activeEle.find('.new_script_name_part').html();
			
			window['coneScriptActive'] = false;
			
			if ( !window['viewCaptured'+userData.id] && ( window['hasConeScript'] || userData.sessionData.calculateAssessmentDimensions == 1 ) && !window['deviceNotSupported'] )
				{
					canStartInjected = false;
					window.stopCircleAnimation = true;
				}
			
			if ( act_type == 'Virtual Equipment' || act_type == 'Virtual Assistant' )
				{
					if ( window['deviceNotSupported'] ) 
						{ 
							$('#virtualmsg').text('Virtual Activity Not Supported on this Device').removeClass('d-none'); 
						}
					else
						{
							var timeoutLength = 1500;
							
							if ( window['viewCaptured'+userData.id] )
								{
									timeoutLength = 0;
								}
								
							setTimeout(function(){
								if ( window['electron'] )
								{
									console.log('timeoutLength');
								}
							}, timeoutLength)
							
						}
				}
			else
				{
					$('#virtualmsg').addClass('d-none');
				}
		}
	else if ( !window['guestUser'] && window['onDemand'] == undefined )
		{
			if ( act_type == 'Virtual Equipment' || act_type == 'Virtual Assistant' )
				{
					$('.acitvity_close_button').trigger('click');
					$('#actStart').html('Start '+script_name);
					window['equipmentIsReady'] = false;
					if ( !window['coneScriptActive'] )
						{
							window['coneScriptActive'] = true;
							window['coneScriptEnd'] = false;
						}
					
					if ( $('.video-holder').length && $('.video-holder').length > 0 )
						{
							let id = $('.video-holder')[0].getAttribute('id');
							let sep = '~@$';
							if ( !window['participantDetails'] || (window['participantDetails'] && !$('#video'+window['participantDetails']['id']).hasClass('video-selected') ) )
								{
									if ( window['participantDetails'] )
										{
											id = window['participantDetails']['id'];
										}
									
									if ( !window['deviceNotSupported'+id] )
										{
											window['participantDetails'] = window.collection.getDetailsById(id);
										}
								}
							
							$('.video-holder').each(function(item, index){
								let parId = $(this).attr('id');
								if ( !window['globalEquipmentObject'+parId] )
									{
										var whiteboardValues = window.currentUserData.whiteboardValues;
										console.log('whiteboardValues', whiteboardValues);
										window['globalEquipmentObject'+parId] = JSON.parse(whiteboardValues['globalEquipmentObject']);
									}
								if ( script_name == 'Lateral Cone Touch' )
									{
										window['globalEquipmentObject'+parId]['currentActivity'] = 'lateralCone';
									}
								else if ( script_name == 'Diagonal Cone Touch' )
									{
										window['globalEquipmentObject'+parId]['currentActivity'] = 'diagonalCone';
									}
								else if ( script_name == 'Boxing Bag 1' )
									{
										window['globalEquipmentObject'+parId]['currentActivity'] = 'boxing';
									}
								else if ( script_name == 'Squat' )
									{ 
										window['globalEquipmentObject'+parId]['currentActivity'] = 'squat';
									}	
								else if ( script_name == 'Agility Ladder' )
									{ 
										window['globalEquipmentObject'+parId]['currentActivity'] = 'agilityLadder';
									}
								else if ( script_name == 'Box Horizontal' )
									{ 
										window['globalEquipmentObject'+parId]['currentActivity'] = 'boxJump';
									}
								else if ( script_name == 'Reaction Drill' )
									{ 
										window['globalEquipmentObject'+parId]['currentActivity'] = 'reactionDrill';
									}
								else if ( script_name == 'Plank Forward Reach' )
									{ 
										window['globalEquipmentObject'+parId]['currentActivity'] = 'plankForward';
									}
								else if ( script_name == 'High Front Plank' )
									{ 
										window['globalEquipmentObject'+parId]['currentActivity'] = 'plankReach';
									}
								else if ( script_name == 'Lateral Resistance Band' )
									{ 
										window['globalEquipmentObject'+parId]['currentActivity'] = 'resistedSideStepping';
									}
								else if ( script_name == 'Lunge' )
									{ 
										window['globalEquipmentObject'+parId]['currentActivity'] = 'lunge';
									}
							});
							
						}
				}
			else
				{
					$('.network-text').addClass('d-none');
					$('.movedEqButtonHold').addClass('d-none');
					$('.actStartHost').addClass('d-none');
					
					if ( window['participantDetails'] )
						{
							let id = window['participantDetails']['id'];
							$('#canvasClearLines'+id).removeClass('d-none');
							$('#canvasCone'+id).removeClass('d-none');
							$('#canvasBag'+id).removeClass('d-none');
							$('#canvasClear'+id).removeClass('d-none');
							$('#canvasSingleCone'+id).removeClass('d-none');
							//$('.share-drawing').addClass('d-none');
							$('.canvas-share').removeClass('d-none');
							$('.palette-dropdown').prop('disabled', false);
						}
					if ( window['canvasOn'] ) 
						{ 
							$('.canvas-close-icon').trigger('click'); 
						}
					
					$('.video-holder').each(function(item, index){
						let parId = $(this).attr('id');
						if ( ( window['hasConeScript'] ) || ( !window['hasConeScript'] && JSON.parse(localStorage.getItem('hostSettings')).calculateAssessmentDimensions == 1 ) )
							{
								if ( parId != userData['id'] && !window['viewCaptured'+parId] && !window['roomSetupDone'+parId] )
									{
										if ( window['deviceNotSupported'+parId] )
											{
												setTimeout(function(){
													if ( window.isPaused ) { $('#virtualmsg-'+parId).text('Device Not Supported').removeClass('d-none'); }
												}, 1000);
											}
										else
											{
												window.stopCircleAnimation = true;
												setTimeout(function(){
													window['participantDetails'] = window.collection.getDetailsById(parId);
													window.pauseSlider();
													window['firstActSetup'+parId] = true;
													console.log('pauseSlider');
													window['startDrawing'](false, parId);
													canStartInjected = false;
													window.showNextActFirst = true;
													window['injectedVideoPause'] = true;
													var canvasSize = {};
													canvasSize['w'] = $('#sessionCanvas'+parId)[0].width;
													canvasSize['h'] = $('#sessionCanvas'+parId)[0].height;
													var email = window['participantDetails']['email'];
													console.log('ROOM INNIT');
													let sep = '~@$';
													let canvasLinesArr = window['canvasLines'+parId] ? window['canvasLines'+parId] : [];
													window['globalRTM'](email, 'draw'+sep+JSON.stringify(canvasLinesArr)+'cSize'+JSON.stringify(canvasSize)+sep+'roomSetup');
												}, 500);
											}
									}
							}
					});
				}
		}
	
    $('#script_name').html(script_name);
	$('.stats_timer_bar').css('width', '0%');
    
    //var indexNum = parseInt(activeEle.find('.data-slide').attr('data-index'));
    var indexNum = getIndexNumber()

    if (window['onDemand'] == undefined) {

        if(activeEle.find('.activityType').text() == 'rest'){
          $('.fitness-emoji').removeClass('d-none');
        } else {
          $('.fitness-emoji').addClass('d-none');

          if (userData.userType == 2) {
              window.resetEvent();
          }

          let emojiCount = $('.fitness-emoji a').length;
          let counter = 0;

          if (emojiCount > 1) {
              
              $('.fitness-emoji a').each(function() {

                  if($(this).hasClass('remote_emoji_selected')) {
                      $(this).removeClass('remote_emoji_selected');
                  }
              });
          }
        }
    }

    countdown = parseInt(countdownNumberEl.html());
	if ( countdown == 0 )
		{
			$('.swiper-slide').removeClass('swiper-slide-next');
			$('#swiper-slide'+indexNum).addClass('swiper-slide-next');
			window.countDown();
			return false;
		}
	
    let scriptCountdown = countdown;
    if ( interval > 1 ) {
      if (activeEle.find('#reps-counter').text() <= 0 && countdown > 0) {
          scriptCountdown = countdown * parseInt(scriptDelay.attr('intervaltime'));
          activeEle.find('#reps-counter').text(scriptCountdown);
      } else {
          scriptCountdown = parseInt(activeEle.find('#reps-counter').text());
      }
    }
	
	activeEle.find('svg circle').css({"animation":"countdown "+scriptCountdown+"s linear infinite forwards", "animation-direction": "reverse"});
	
	if ( window.stopCircleAnimation )
		{
			activeEle.find('svg circle').css({"animation-play-state":"paused"});
		}
    
    var equipmentCountdown = 1;
    resetCount = setInterval(function() {
		
		if ( window['changeCountdown'] )
			{
				countdown = $('#activityCounter .counter-number').text();
				window['changeCountdown'] = false;
			}
			
		if ( window['playCountdown'] && equipmentCountdown > 0 )
			{
				if ( window['playReadySet'] )
					{
						window['playReadySet']();
					}
				else
					{
						window.isPaused = true;
						
						setTimeout(function() {
							window['playCountdown'] = false;
							window.isPaused = false;
						}, 3000);
					}
				
				equipmentCountdown--;
			}
		
      if(window.isPaused === false) {
		
		if ( countdown > 5 && window['startRecordingTest'] )
			{
				window['startRecordingTest'](true);
			}
		if ( !window.stopCircleAnimation )
			{
				activeEle.find('svg circle').css({"animation-play-state":"running"});
			}
		else
			{
				window.stopCircleAnimation = false;
			}

        if (interval > 1) {
            scriptCountdown--;
            activeEle.find('#reps-counter').text((scriptCountdown > 0 ? scriptCountdown : 0));

            if (scriptCountdown%interval === 0) {
                countdown--;
				var timeCount = getTimerFormat(countdown);
                countdownNumberEl.text((countdown > 0 ? countdown : 0)) ;
                $('#script_time').text((countdown > 0 ? countdown : 0)) ;
                $('#activityCounter .counter-number').text((countdown > 0 ? countdown : 0)) ;
                $('#workoutTimer').text((countdown > 0 ? timeCount : '00:00')) ;
				let progressBarWidth = barIncreaseNum*(startTime-countdown);
				$('.stats_timer_bar').css('width', progressBarWidth+'%');
            }
        } else {
            countdown--;
			var timeCount = getTimerFormat(countdown);
            countdownNumberEl.text((countdown > 0 ? countdown : 0));
            $('#script_time').text((countdown > 0 ? countdown : 0));
            $('#activityCounter .counter-number').text((countdown > 0 ? countdown : 0));
            $('#workoutTimer').text((countdown > 0 ? timeCount : '00:00'));
			let progressBarWidth = barIncreaseNum*(startTime-countdown);
			
			if ( progressBarWidth > 96 ) { progressBarWidth = 100; }
			
			$('.stats_timer_bar').css('width', progressBarWidth+'%');
        }

        if(repeatVdo == 0)
        {
            var video = null;

            if ( userData.userType == 1 ) {
                video = $("#agora_local_inject").find("video");
            } else {
                video = $('#video_prerecorded');
            }
			
			if ( !video ) { video = $('#host_inj_video'); }

            if( video.length > 0 && video.attr('src') != '' && video.attr('src') != undefined )
            {
                var currentTime = Math.floor(video[0].currentTime);

                console.log('##currentTime - ', currentTime, typeof currentTime);

                if( currentTime == window['videoDuration'] )
                {
					if ( ( act_type !== 'Virtual Equipment' && act_type !== 'Virtual Assistant' ) && window['hasConeScript'] && !window['viewCaptured'+userData.id] )
						{
							window['pauseBeforeEquipmentInjected'] = true;
						}
					
                    window.removeInjectVideo(url);
                    url = null;
                    repeatVdo = '';
                }
            }
        }
		
        if(countdown < 1) { 

			let _el = $('.swiper-slide.swiper-slide-next');
			let scriptLengthNew = $('.swiper-slide .data-slide').length;
			let scriptIndexNew = parseInt(_el.find('.data-slide').attr('data-index'));
			
			if ( window['onDemand'] && scriptIndexNew < scriptLengthNew && ( !userData || !userData.sessionData || userData.sessionData.manualAutomaticScript == 0 ) )
				{
					$('#canvasWrap').removeClass('d-none');
					$('#toolTip .tooltipNumber').addClass('d-none');
					$('#toolTip').removeClass('d-none');
					
					$('.tooltipText').html('Waiting for Instructor to start next activity');
					$('.part_inner').html('');
					$('.walk_tool_text').html('');
					$('.hostToolTip, #walkToolImage, .upNext').removeClass('d-none');
					$('#walkToolImage').addClass('d-none');
					$('#walkToolImageDem').addClass('d-none');
				}
			

            if ( url !== null )
            {
                window.removeInjectVideo(url);
                url = null;
				window['injectedVideoInProgress'] = false;
            }

			if ( (act_type == 'Virtual Equipment' || act_type == 'Virtual Assistant') && window['coneScriptActive'] )
				{
					window['coneScriptActive'] = false;
					window['coneScriptEnd'] = true;
				}


            activeEle.find('svg circle').css({"animation":"countdown 0s linear infinite forwards", "animation-direction": "reverse"});
            activeEle.find('svg circle').css({"animation-play-state":"paused"});
            clearInterval(resetCount);
			
			if ( !window['guestUser'] )
				{
					 clearInterval(updateCount);
				}
           
            window.isPaused = true;

            $('#pause-slider').addClass('d-none').removeClass('d-inline-block');

            if( $('.swiper-slide .data-slide').length == indexNum ) {
				localStorage.removeItem("scriptDetailsObject");
                if (window['onDemand'] == undefined) {
                    $('.fitness-emoji').removeClass('d-none');
                }

                $('.swiper-guest.end').addClass('swiper-slide-next');
                activeEle.find('svg circle').removeAttr("style");
                activeEle.find('svg').removeAttr("style");
                activeEle.removeClass('swiper-slide-next');
				if ( window['canvasOn'] ) { $('.canvas-close-icon').trigger('click'); }
				//$('#fitness-counter').text(scriptLength);
				
				if ( userData.sessionData.manualAutomaticScript == 0 && (act_type == 'Virtual Equipment' || act_type == 'Virtual Assistant') && window['guestUser'] ) {
					//if ( window['updateOverSound'] ) { console.log('soundtest'); window['updateOverSound'](); }
				}
				window['injectedVideoInProgress'] = false;
            } else {
                if (userData.userType == 1 && userData.sessionData.manualAutomaticScript == 1 && window['onDemand'] == undefined) {
                    setTimeout(function(){
						this.playNextScript();
                    }, 1000);
                } else if ( userData.sessionData.manualAutomaticScript == 0 && (act_type == 'Virtual Equipment' || act_type == 'Virtual Assistant') ) {
					//if ( window['updateOverSound'] ) { window['updateOverSound'](); }
				}
            }

            let slideId = activeEle.attr('id');
            $('#activity-'+slideId).removeClass('activity-current');
			window['activityEnded'] = true;
        }      

		if ( countdown == 1 && !window['guestUser'] && (!window['onDemand'] || window['onDemand'] == undefined) ) {
			if ( (act_type == 'Virtual Equipment' || act_type == 'Virtual Assistant' ) && window['coneScriptActive'] ) {
				
				window['pauseActivity'](false, true);
				
			}
			else if ( (act_type_next == 'Virtual Equipment' || act_type_next == 'Virtual Assistant') && (act_type != 'Virtual Equipment' && act_type != 'Virtual Assistant') && window['onDemand'] == undefined ) {
				var stopAct = false;
				 $('.video-holder').each(function(item, index){
				   let parId = $(this).attr('id');
					  if ( parId != userData['id'] )
						{
							if ( ( window['canvasLines'+parId] && window['canvasLines'+parId].length > 0 ) || window['gridOn'] )
								{
									stopAct = true;
								}
						}
				 });
				 if (stopAct)
					{
						window['pauseActivity'](true, false, false, true);
					}
				else 
					{
						
						window['pauseActivity'](true, false);
					}					
				
				
			}
			else if ( (act_type != 'Virtual Equipment' && act_type != 'Virtual Assistant') && window['onDemand'] == undefined ) {
				var stopAct = false;
				 $('.video-holder').each(function(item, index){
				   let parId = $(this).attr('id');
					  if ( parId != userData['id'] )
						{
							if ( ( window['canvasLines'+parId] && window['canvasLines'+parId].length > 0 ) || window['gridOn'] )
								{
									stopAct = true;
								}
						}
				 });
				
				 if ( stopAct )
					{
						
						window['pauseActivity'](true, false, true, true);
					}
			}
		}
			
      } else {
          activeEle.find('svg circle').css({"animation-play-state":"paused"});
      }
    }, 1000);
	
	setTimeout(function () {
	if( getInjectEle.length === 1 && window['onDemand'] == undefined && canStartInjected ) 
		{
			url = getInjectEle.attr('value');
			setTimeout(function () { 
				if ( window['addInjectVideo'] )
					{
						window.addInjectVideo(url); 
					}
			}, 300);
			window['injectedVideoInProgress'] = true;
			$('.paletteHolder').addClass('d-none');
		}
	}, 600);
	
	var activityArray = JSON.parse(localStorage.getItem('userData')).sessionData.scriptDetail;
	var currentActivityIndex = (getIndexNumber() - 1);
	var currentActivity = activityArray[currentActivityIndex];
	if ( currentActivity && currentActivity.attribute && currentActivity.attribute[10] && currentActivity.attribute[10].attrValue && currentActivity.attribute[10].attrValue !== null && parseInt(currentActivity.attribute[10].attrValue) > 0 )
		{
			var stationId = parseInt(currentActivity.attribute[10].attrValue);
			var stationName = parseInt(currentActivity.attribute[11].attrValue);
			playerFunctions.stopPlayer();
			playerFunctions.playPlayer(stationId, stationName);
			window['showPlayerDemand'](true);
		}
	else
		{
			playerFunctions.stopPlayer();
			window['showPlayerDemand'](false);
		}
  }
  

  window.loadSwiperSlide = () => {

      clearInterval(resetCount);
	  
	  if ( !window['guestUser'] )
		{
			clearInterval(updateCount);
		}
		
      if (url !== null) {
          window.removeInjectVideo(url);
          url = null;
      }

      let activeEle = $('.swiper-slide .countdown');

      activeEle.each(function(i, val){
          $(this).find('.countdown-number').text( parseInt($(this).find('.countdown-number').attr('data-number')));
          $(this).find('#reps-counter').text(0);
      });

      let activeEle1 = $('.swiper-slide.swiper-slide-next');
      activeEle1.find('svg circle').removeAttr("style");

      $('.activity_list_popup .script-list').each(function(i, val){
          $(this).removeClass('activity-current');
      });
  }

  window.loadSwiperSlide1 = () => {
      $('.fitness-emoji').addClass('d-none');

      clearInterval(resetCount);
	  
	  if ( !window['guestUser'] )
		{
			clearInterval(updateCount);
		}

      if (url !== null) {
          window.removeInjectVideo(url);
          url = null;
      }

      let swiperEle = $('.swiper-slide .count-timer');
      swiperEle.each(function(i, val){
          let counter = $(this).find('.countdown-number').attr('data-number');
          $(this).find('.countdown-number').text(parseInt(counter));
          $(this).find('svg circle').removeAttr('style');
          $(this).find('#reps-counter').text(0);
      });

      $('.activity_list_popup .script-list').each(function(i, val){
          $(this).removeClass('activity-current');
      });
  }

  window['activityStats'] = {};
	
  window.playNextScript = () => {
	  window['timerStartedBag'] = false;
	  window['timerStartedBox'] = false;
	  window['wentInsideBag'] = false;
	  window['wentInsideBox'] = false;
	  window['timerStartedEq'] = false;
	  window['wentInsideCone'] = false;
	  window['wentInside'] = false;
	  window['injectedVideoInProgress'] = false;
      let _el = $('.swiper-slide.swiper-slide-next');
      let scriptIndex = parseInt(_el.find('.data-slide').attr('data-index'));
	  
	  let scriptDetailsObject = { 'sessionId': 0, 'scriptIndex': 0};
	  let sessionId = userData.sessionData.id;
	  scriptDetailsObject['sessionId'] = sessionId;
	  scriptDetailsObject['scriptIndex'] = scriptIndex;
	  
	  localStorage.setItem("scriptDetailsObject", JSON.stringify(scriptDetailsObject));

	  let act_type_previous = window['checkActivityType'](scriptIndex-1);
	  let act_type = window['checkActivityType'](scriptIndex);
	  $('#inZoneStatus'+userData.id).addClass('d-none');
	  $('.activity_list_popup .script-list').each(function(i, val){
          $(this).removeClass('activity-current');
      });
      
      if (url !== null) {
          window.removeInjectVideo(url);
          url = null;
      }
	  
      if (scriptIndex < scriptLength) {
          _el.find('svg circle').removeAttr("style");
          _el.find('.countdown-number').text('0');
          _el.find('#reps-counter').text(0);

          clearInterval(resetCount);
          clearInterval(updateCount);
          window.mySwiper.slideNext();
          window.countDown();

          _el = $('.swiper-slide.swiper-slide-next');
          let scriptName = _el.find('.scriptName').text();

          window.moveToNextScript(scriptIndex, scriptName);

          window.isPaused = false;
          $('#pause-slider').removeClass('d-none').addClass('d-inline-block');
          $('#play-slider').addClass('d-none').removeClass('d-inline-block');
		  $('#script_msg').addClass('d-none');
		  //$('#script_msg_par').addClass('d-none');
		  $('.walk_tool_image').css('background-image', 'none');
		  $('#partToolTip').addClass('d-none');
		  $('#walkToolImage').addClass('d-none');
		  $('#upNextText').addClass('d-none');
		  $('#upNextText').html('');
		  $('.walk_tool_text').html('');
		  $('#partToolTip .tooltipText').html('');
		  $('#partToolTip .part_inner').html('');
		  $('.hostToolTip, .walk_tool_hold, .upNext, #activityStart').addClass('d-none');
		  $('.tooltipSuccess').addClass('d-none');
		  
		  if ( (act_type_previous == 'Virtual Equipment' || act_type_previous == 'Virtual Assistant') )
		    {
				for ( var i = 0; i < $('.rep-count').length; i++ )
					{
						if ( !$('.rep-count')[i].classList.contains('ppm_count') )
							{
								var partId = $('.rep-count')[i].id.split('repCount')[1];
								var previousActivity = userData.sessionData.scriptDetail[scriptIndex-1];
								var statsObj = {
									'actId': previousActivity['id'],
									'actName': previousActivity['name'],
									'duration': previousActivity['attribute'][2]['attrValue'],
									'reps': $('#repCount'+partId).html(),
									'rpm': $('#ppmCount'+partId).find('.counter-number').html()
								};
								
								if ( !window['activityStats'][partId] )
									{
										window['activityStats'][partId] = {};
									}
								window['activityStats'][partId][previousActivity['id']] = statsObj;
							}
					}
				
				console.log(window['activityStats'], 'STATS');
				
				if ( window['canvasOn'] )
					{
						window['clearCones']();
					}
					
				if ( act_type !== 'Virtual Equipment' && act_type !== 'Virtual Assistant' && window['participantDetails'] && window['canvasLines'+window['participantDetails']['id']].length == 0 )
					{
						window['closeDrawing']('auto');
					}
			}
			
          if ((scriptIndex + 1) === scriptLength) {
              $('#next-script').addClass('d-none').removeClass('d-inline-block');
          }
      }
	  
	  if ( act_type == 'Virtual Equipment' || act_type == 'Virtual Assistant' )
		  {
			  $('.paletteHolder').addClass('d-none');
		  }
  }

  window.playNextScriptParticipant = (scriptIndex) => {
	  console.log('----------playNextScriptParticipant------');
	  window['timerStartedBag'] = false;
	  window['timerStartedBox'] = false;
	  window['wentInsideBag'] = false;
	  window['wentInsideBox'] = false;
	  window['timerStartedEq'] = false;
	  window['wentInsideCone'] = false;
	  window['wentInside'] = false;
	  window['pauseBeforeEquipmentInjected'] = false;
	  window['firstCircleShown'+userData.id] = false;
	  window['stoodInBox'+userData.id] = false;
	  window['boxZoneSet'] = false;
	  window['plankZoneSet'] = false;
	  window['plankReachZoneSet'] = false;
	  window['drillZoneSet'] = false;
	  window['steppingZoneSet'] = false;
	  window['showTargetCircle'+userData.id] = true;
	  window['showTargetCircleRight'+userData.id] = false; 
	  window['showTargetCircleMiddle'+userData.id] = false;
	  let _el = $('.swiper-slide.swiper-slide-next');
	  let scriptIndexPar = parseInt(_el.find('.data-slide').attr('data-index'));
	  let act_type_par = window['checkActivityType'](scriptIndex);
	  console.log(act_type_par, 'act_type1');
	  window['hostStartedEquipment'+userData.id] = false;
	  if ( act_type_par == 'Virtual Equipment' || act_type_par == 'Virtual Assistant' )
		  {
			  $('#bpm').attr('style','display: none !important');
			  $('.allSupport').addClass('d-none');
			  if ( window['viewCaptured'+userData.id] )
				  {
					  //$('.participant_stats_hold').removeClass('d-none');
				  }
				  
			  window['setTrackerBackground'+userData.id] = false;
		  }
		  
     else
		 {
			  //$('#bpm').attr('style','display: inline-block !important');
			  $('.participant_stats_hold').addClass('d-none');
			  $('.allSupport').removeClass('d-none');
		 }
	  
      $(".swiper-slide.start a").prop('disabled', true);
      $(".start").removeClass("swiper-start");

      clearInterval(resetCount);

      if (url !== null) {
          window.removeInjectVideo(url);
          url = null;
      }

      let isIndexSet = false;
      $('.swiper-slide').each(function (index, value) {
          if(parseInt($(this).attr('data-index')) <= scriptIndex)
          {
              let activeEle = $('.swiper-slide.swiper-slide-next');
              activeEle.find('svg circle').removeAttr("style");
              activeEle.find('.countdown-number').text('0');
              activeEle.find('#reps-counter').text(0);

              $('#activity-'+activeEle.attr('id')).removeClass('activity-current');
          }

          if( parseInt($(this).attr('data-index')) == scriptIndex+1 && isIndexSet === false )
          {
              scriptIndex = parseInt($(this).find('.data-slide').attr('data-index-counter'));
              isIndexSet = true;
          }
      });

		window.mySwiper.slideTo(scriptIndex);
		window.countDown();
  }

  window.syncScriptOnDemand = (scriptIndex) => {
      $(".swiper-slide.start a").prop('disabled', true);
      $(".start").removeClass("swiper-start");
      
      clearInterval(resetCount);

      let isIndexSet = false;
      $('.swiper-slide').each(function (index, value) {

          if(parseInt($(this).attr('data-index')) <= scriptIndex) {

              let activeEle = $('.swiper-slide.swiper-slide-next');
              activeEle.find('svg circle').removeAttr("style");
              activeEle.find('.countdown-number').text('0');
              activeEle.find('#reps-counter').text(0);
              $('#activity-'+activeEle.attr('id')).removeClass('activity-current');
			  
			  if ( $('.tooltipText').html() == 'Waiting for Instructor to start next activity' )
				{
					$('#toolTip .tooltipNumber').addClass('d-none');
					$('#toolTip').addClass('d-none');
					$('.tooltipText').html('');
					$('.part_inner').html('');
					$('.walk_tool_text').html('');
					$('.hostToolTip, #walkToolImage, .upNext').addClass('d-none');
					$('#walkToolImage').addClass('d-none');
					$('#walkToolImageDem').addClass('d-none');
				}
          }

          if( parseInt($(this).attr('data-index')) == scriptIndex && isIndexSet === false )
          {
              scriptIndex = parseInt($(this).find('.data-slide').attr('data-index-counter'));
              isIndexSet = true;
          }
      });

      window.mySwiper.slideTo(scriptIndex);
      window.countDown();
  }

  function getIndexNumber() {

      let indexNum = 0;
      let nextFound = false;

      $('.swiper-slide').each(function (index, value) {

          if( $(this).find('.data-slide').length === 1 )
          {
              if( $(this).hasClass('swiper-slide-next') )
              {
                  nextFound = true;
                  indexNum++;
              }
              else if ( nextFound === false )
              {
                  indexNum++;
              }
          }
      });

      return indexNum;
  }
  
	window.slideAfterRejoin = (scriptIndex) => {
		window.mySwiper.slideTo(scriptIndex);
	}
	
	function getTimerFormat(duration){
		// Hours, minutes and seconds
		var hrs = ~~(duration / 3600);
		var mins = ~~((duration % 3600) / 60);
		var secs = ~~duration % 60;

		// Output like "1:01" or "4:03:59" or "123:03:59"
		var ret = "";

		if (hrs > 0) 
			{
				ret += "" + hrs + ":" + (mins < 10 ? "0" : "");
				$('#workoutTimer').addClass('smaller_timer');
			}
		else
			{
				$('#workoutTimer').removeClass('smaller_timer');
			}
			
		if ( mins == 0 ) { mins = "0"+mins };
		
		ret += "" + mins + ":" + (secs < 10 ? "0" : "");
		ret += "" + secs;
		return ret;
	}
}

export default initFitnessJS;